
import { Component, Vue, Watch } from "vue-property-decorator";
import * as echarts from "echarts";
import {
  DashTopData,
  PeopleData,
  TimeData,
  AllExam,
  ecOptionLD,
  ecOptionWhen,
  ecOptionLong,
  AddAlways
} from "@/lib/dash/dash";
import Auth from "@/lib/common/auth";
import { ExamGetForm, UploadParamsForm } from "@/lib/form/exam/ExamListForm";
import ExamList from "@/lib/model/exam/exam";
import ModalTitle from "@/lib/model/exam/modal-title";
import track from "@/lib/common/track";
import ModalHeader from "@/components/modal-header.vue";
import ExamLink from "@/components/modal-examlink.vue";
import vuexStore from "@/store/vuex-store";
import {
  CandidateMCreateParams,
  CandidateMCreateParseParams
} from "@/lib/model/exam/candidate";
import CandidateCreateForm, {
  StructParam
} from "@/lib/form/candidate/CandidateCreateForm";
import AddOneCandidateModal from "@/views/paper/components/add-one-candidate-new.vue";
import AddMoreCandidateModal from "@/views/paper/components/add-more-candidate-new.vue";

@Component({
  components: {
    ModalHeader,
    ExamLink,
    AddOneCandidateModal,
    AddMoreCandidateModal
  }
})
export default class Dash extends Vue {
  ecOptionLD = ecOptionLD; //ec配置
  ecOptionWhen = ecOptionWhen; //
  ecOptionLong = ecOptionLong; //
  alwaysExamList: any = []; //常用面试列表
  alwaysExamDataReady = false;
  topData = new DashTopData(); //顶部卡片数据
  peopleData = new PeopleData(); //漏斗数据
  timeData = new TimeData(); //时长数据
  allExam = new AllExam(); //全部面试
  searchInputValue = "";
  timeDur = 7;
  selectExamId = "0";
  show = false;
  V = vuexStore;

  searchText = ""; //弹窗搜索常
  selectedExamList: any = []; //弹窗已选

  //展示二维码相关
  examGetForm: ExamGetForm = new ExamGetForm();
  link = "";
  scanLink = "";
  scanUrl = "";
  modalTitle: ModalTitle = new ModalTitle();
  showExamUrl = false;
  currentPaperId = 0;
  examName = "";
  examRemark = "";

  //添加候选人相关
  uploadParams = new UploadParamsForm();
  candidateMCreateParseParams = new CandidateMCreateParseParams();
  candidateMCreateParams = new CandidateMCreateParams();
  candidateCreateForm = new CandidateCreateForm();
  isShowAddMore = false;
  isShowAddOne = false;
  structParams: StructParam[] = new Array<StructParam>();
  clickAlwaysExamId = 0;

  //新功能引导
  newTip = [true, false, false, false];
  newGuide = false; //是否走新手引导流程

  //下拉搜索匹配
  get getOptions() {
    if (this.searchInputValue) {
      const t = this.allExam.list.filter(d =>
        d.name.includes(this.searchInputValue)
      );
      return [...t];
    } else {
      return [...this.allExam.list];
    }
  }

  //弹窗搜索匹配
  get getOptionsAlways() {
    if (this.searchText) {
      const t = this.allExam.list.filter(d => d.name.includes(this.searchText));
      track("dashboard_page_interact", {
        company_id: Auth.companyId,
        company_name: this.V.company.name,
        card_type: "常用面试卡片",
        operation_name: "搜索面试名称"
      });
      return t;
    } else {
      return this.allExam.list;
    }
  }
  //弹窗选中样式
  ed(d: any) {
    let flag = false;
    this.selectedExamList.map((m: any, i: number) => {
      if (m.examId === d.examId) {
        flag = true;
        return;
      }
    });
    return flag;
  }
  //登录或跳转 有comapnyId后再调
  @Watch("$route.query.companyId", { deep: true, immediate: true })
  gd(n: any, o: any) {
    if (n !== o && n) {
      // this.getAllData();
    }
  }
  //数值 1w+
  formatNumber(n: string | number) {
    n = String(n);
    const num = parseInt(n, 10);
    if (isNaN(num)) {
      return n;
    }
    if (num < 10000) {
      return n;
    }
    return `${(num / 10000).toFixed(1)}w+`;
  }
  created() {
    if (Auth.token) {
      // document.title = "海纳AI面试";
      const thisIsAGetLikeSet = Auth.companyId; //触发一下
      console.log(thisIsAGetLikeSet);
      // if (this.$route.query?.L === "1") {
      //   //登录后跳转 等待账户信息更新后加载
      //   setTimeout(() => {
      //     this.getAllData();
      //     window.history.replaceState("", "", this.$route.path);
      //   }, 500);
      // } else {
      //   this.getAllData();
      // }
      this.getAllData();

      //新手引导
      if (localStorage.getItem("showNewTip") !== "1") {
        this.newGuide = true;
      }
      //未登录
    } else {
      this.$router.push("/").catch(err => err);
    }
  }
  //加载所有数据
  getAllData() {
    this.getTop();
    //漏斗信息
    this.getLD();
    //时长信息
    TimeData.get(Number(Auth.companyId)).then(res => {
      this.timeData = res;
      this.setEchartWhen();
      this.setEchartLong();
    });
    AllExam.get(Number(Auth.companyId)).then(res => {
      this.allExam = res;
    });
  }
  //左侧漏斗交互
  selectLD(str: string) {
    this.ecOptionLD.legend.selected[str] = !this.ecOptionLD.legend.selected[
      str
    ];
    this.setEchartLD();
    track("dashboard_page_interact", {
      company_id: Auth.companyId,
      company_name: this.V.company.name,
      card_type: "数据监控卡片",
      operation_name: str + "筛选点击"
    });
  }
  //顶部信息
  getTop() {
    DashTopData.get(Number(Auth.companyId)).then(res => {
      this.topData = res;
      this.alwaysExamList = res.examCommonlyUsedList;
      this.selectedExamList = JSON.parse(JSON.stringify(this.alwaysExamList));
      this.alwaysExamDataReady = true;
    });
  }
  get showAlwaysExamList() {
    return this.alwaysExamList.slice(0, 4);
  }
  //获取漏斗
  getLD() {
    PeopleData.get(
      Number(Auth.companyId),
      Number(this.selectExamId),
      Number(this.timeDur)
    ).then(res => {
      this.peopleData = res;
      this.setEchartLD();
    });
  }
  //漏斗EC
  setEchartLD() {
    //
    const echart = echarts.init(this.$refs.ecLD as any);
    if (echart) {
      this.ecOptionLD.xAxis[0].data = this.peopleData.detail.headers;
      this.ecOptionLD.series[0].data = this.peopleData.detail.rowCreate;
      this.ecOptionLD.series[1].data = this.peopleData.detail.rowLogin;
      this.ecOptionLD.series[2].data = this.peopleData.detail.rowSubmitFinish;
      this.ecOptionLD.series[3].data = this.peopleData.detail.rowAuditPass;
      echart.clear();
      echart.setOption(this.ecOptionLD);
      echart.on("legendselectchanged", (p: any) => {
        this.ecOptionLD.legend.selected = p.selected;
        track("dashboard_page_interact", {
          company_id: Auth.companyId,
          company_name: this.V.company.name,
          card_type: "数据监控卡片",
          operation_name: p.name + "筛选点击"
        });
      });
      window.addEventListener("resize", () => {
        echart.resize();
      });
    }
  }
  //何时参加EC
  setEchartWhen() {
    const echart = echarts.init(this.$refs.ecWhen as any);
    if (echart) {
      this.ecOptionWhen.xAxis[0].data = this.timeData.byBeginTime.headers;
      this.ecOptionWhen.series[0].data = this.timeData.byBeginTime.row;
      echart.setOption(this.ecOptionWhen);
      window.addEventListener("resize", () => {
        echart.resize();
      });
    }
  }
  //面试时长EC
  setEchartLong() {
    const echart = echarts.init(this.$refs.ecLong as any);
    if (echart) {
      this.ecOptionLong.xAxis[0].data = this.timeData.byTimeDuration.headers;
      this.ecOptionLong.series[0].data = this.timeData.byTimeDuration.row;
      echart.setOption(this.ecOptionLong);
      window.addEventListener("resize", () => {
        echart.resize();
      });
    }
  }
  showAlways() {
    this.show = true;
    track("dashboard_page_interact", {
      company_id: Auth.companyId,
      company_name: this.V.company.name,
      card_type: "常用面试卡片",
      operation_name: "打开常用面试设置弹窗"
    });
  }

  //选择面试
  selectExam(name?: string) {
    this.getLD();
    track("dashboard_page_interact", {
      company_id: Auth.companyId,
      company_name: this.V.company.name,
      card_type: "数据监控卡片",
      operation_name: name + "筛选"
    });
  }
  //头像缺失
  defImg(event: any) {
    //
  }
  //漏斗百分比
  countPercent(num: number, father: number) {
    const t = Math.floor((num / father) * 100);
    return t || 0;
  }
  //头像数量处理
  getSix(list: []) {
    return list.length > 6 ? list.slice(0, 6) : list;
  }
  //弹窗选中面试
  addAlwaysExam(item: any) {
    const i = this.selectedExamList.findIndex(
      (d: any) => d.examId === item.examId
    );
    if (i !== -1) {
      this.selectedExamList.splice(i, 1);
      this.$forceUpdate();
    } else {
      if (this.selectedExamList.length < 4) {
        this.selectedExamList.push(item);
        this.$forceUpdate();
      } else {
        this.$message.warning("最多可设置4个常用面试");
      }
    }
  }
  //保存常用面试
  okAlways() {
    const params: any = {};
    params.companyId = Auth.companyId;
    params.commonlyUsedExamIdList = this.selectedExamList.map((d: any) => {
      return d.examId;
    });
    AddAlways.set(params).then(() => {
      this.$message.success("修改成功");
      this.show = false;
      this.getTop();
    });
    track("dashboard_page_interact", {
      company_id: params.companyId,
      company_name: this.V.company.name,
      selected_exam_list: params.commonlyUsedExamIdList
    });
  }
  close() {
    this.show = false;
    setTimeout(() => {
      this.selectedExamList = JSON.parse(JSON.stringify(this.alwaysExamList));
    }, 500);
  }
  //跳转候选人列表
  toPage(key: string) {
    this.$router.push({
      name: "exam-candidate",
      query: {
        [key]: "1"
      }
    });
    track("dashboard_page_interact", {
      company_id: Auth.companyId,
      company_name: this.V.company.name,
      card_type: key === "today" ? "今日完成面试数卡片" : "待评估人数卡片",
      operation_name:
        key === "today" ? "今日完成面试数卡片点击" : "待评估人数卡片点击"
    });
  }
  //指定面试
  toPageExam(item: any) {
    this.$router.push({
      name: "exam-candidate",
      query: {
        paperId: item.examId
      }
    });
  }

  //展示面试二维码
  showQRCode(row: any) {
    track("dashboard_page_interact", {
      company_id: Auth.companyId,
      company_name: this.V.company.name,
      card_type: "常用面试卡片",
      operation_name: "面试链接按钮点击"
    });
    this.modalTitle.hasDesc = true;
    this.modalTitle.desc = row.name;
    this.examName = row.name;
    this.examRemark = row.remark;
    this.currentPaperId = row.examId;
    // 面试链接dialog
    this.examGetForm.examId = row.examId;
    this.examGetForm.companyId = parseInt(Auth.companyId);
    this.showExamUrl = true;
    ExamList.wsaCode(this.examGetForm)
      .then(res => {
        if (res.code === 0) {
          this.scanLink = "data:image/png;base64," + res.data.base64string;
          // this.scanUrl = `${Config.aiInterviewHost}/exam/sign?connectCode=${row.connectCode}`;
          this.modalTitle.title = "面试链接";
        }
      })
      .then(() => {
        ExamList.examUrl(this.examGetForm).then(urlRes => {
          if (urlRes.code === 0) {
            this.scanUrl = urlRes.data.url;
          }
        });
      });
    track("exam_page_interact", {
      exam_id: row.examId,
      exam_name: row.name,
      exam_remark: row.remark,
      operation_type: "按钮点击",
      operation_name: "面试链接"
    });

    // 神策埋点
    track("click_exam_link", {
      exam_id: row.examId,
      exam_name: row.name,
      is_click: true,
      operation_type: "按钮点击",
      operation_name: "点击面试链接按钮"
    });
  }

  //添加候选人
  showAdd(event: string, row: ExamList) {
    track("dashboard_page_interact", {
      company_id: Auth.companyId,
      company_name: this.V.company.name,
      card_type: "常用面试卡片",
      operation_name: "添加候选人按钮点击"
    });
    this.modalTitle.desc = row.name;
    this.examName = row.name;
    this.examRemark = row.remark;
    this.examGetForm.examId = row.examId;
    this.examGetForm.companyId = parseInt(Auth.companyId);
    this.uploadParams.ucCompanyId = parseInt(Auth.companyId);
    this.uploadParams.examId = row.examId;
    this.candidateMCreateParseParams.companyId = parseInt(Auth.companyId);
    this.candidateMCreateParseParams.examId = row.examId;
    this.candidateMCreateParams.examId = String(row.examId);
    this.candidateMCreateParams.companyId = Auth.companyId;
    this.clickAlwaysExamId = Number(row.examId);
    if (event == "showAddOne") {
      track("exam_page_interact", {
        exam_id: this.examGetForm.examId,
        exam_name: this.examName,
        exam_remark: this.examRemark,
        operation_type: "按钮点击",
        operation_name: "添加一位候选人"
      });
      this.modalTitle.title = "添加一位候选人";
      ExamList.examGet(this.examGetForm)
        .then(res => {
          this.candidateCreateForm.paramList = res.paramList.filter(
            (e: StructParam) => {
              return e.isShow == 1;
            }
          );
          this.candidateCreateForm.companyId = this.examGetForm.companyId;
          this.candidateCreateForm.examId = this.examGetForm.examId;
        })
        .finally(() => {
          this.isShowAddMore = false;
          this.isShowAddOne = true;
        });
    } else if (event === "showAddMore") {
      track("exam_page_interact", {
        exam_id: this.examGetForm.examId,
        exam_name: this.examName,
        exam_remark: this.examRemark,
        operation_type: "按钮点击",
        operation_name: "批量添加候选人"
      });
      this.modalTitle.title = "批量添加候选人";
      this.isShowAddOne = false;
      this.isShowAddMore = true;
    }
  }
  //关闭弹窗
  handleMoreClose() {
    track("click_add_candidate", {
      exam_id: this.candidateMCreateParams.examId,
      exam_name: this.examName,
      exam_remark: this.examRemark,
      add_type: "批量添加",
      operation_type: "按钮点击",
      operation_name: "导入",
      click_from: "AI面试列表页"
    });
    this.isShowAddOne = false;
    this.isShowAddMore = false;
  }

  addSubmit() {
    track("click_add_candidate", {
      exam_id: this.candidateMCreateParams.examId,
      exam_name: this.examName,
      exam_remark: this.examRemark,
      add_type: "添加一位",
      operation_type: "按钮点击",
      operation_name: "完成",
      click_from: "AI面试列表页"
    });
    this.isShowAddOne = false;
  }
  //引导下一步
  guideNext(i: number) {
    this.newTip[i] = false;
    this.newTip[i + 1] = true;
    this.$forceUpdate();
  }
  //引导上一步
  guidePre(i: number) {
    this.newTip[i] = false;
    this.newTip[i - 1] = true;
    this.$forceUpdate();
  }
  //新手引导完毕
  guideOver() {
    localStorage.setItem("showNewTip", "1");
    this.newGuide = false;
  }
}
